<template>
    <div class="box">
        <div>
            <div class="header">
                <Row v-if="hasPermission('addLiveRoom')" type="flex" class="toolbar">
                    <Col span="19">
                    <Button
                            icon="md-add"
                            type="primary"
                            @click="$router.push(listType!='slowlive'?'detail/edit/0':'detail/editslowlive/0')"
                    >{{ listType!='slowlive'?$t('liveRoomManagement.liveRoomList.List.addLiveRoom'):'添加慢直播间' }}</Button>
                    </Col>
                    <!-- 
                    <Col v-if="filter.selectType == 2" style="text-align:left;float:left" span="5">
                            <div class="department-bar" style="display: inline-block">
                                <span>{{ $t('Home.Header.department') }}</span>
                                <span class="department-text"  @click.stop="departmentBar.selecting = !departmentBar.selecting">
                                    <span :title="departmentName">{{departmentName}}</span>
                                    <icon class="icon" :type="departmentBar.selecting ? 'md-arrow-dropup' : 'md-arrow-dropdown'"></icon>
                                 <div class="department-select" v-show="departmentBar.selecting" @click.stop="departmentBar.selecting = true">
                                <Tree ref="departmentBarTree" :data="departmentBar.treeData" show-checkbox check-directly check-strictly
                                      @on-check-change="onDepartmentTreeCheck"></Tree>
                                </div>
                                </span>
                            </div>            
                    </Col>
                    -->
                </Row>

                <!--筛选栏-->
                <div class="filter">
					<div style="float:right">
						<Button style="margin-right:10px" :icon="advanceSearch?'ios-arrow-up':'ios-arrow-down'" @click="advanceSearch=!advanceSearch">{{$t('高级搜索')}}</Button>
						<Button type="primary" @click="refresh">{{$t('刷新')}}</Button>
					</div>
                    <ul class="filter-box">
                        <li>
                            <span>{{ $t('liveRoomManagement.liveRoomList.List.filter.roomId') }}</span>
                            <Input
                                class="selector"
                                v-model="filter.roomId"
                                size="small"
                                clearable
                                :placeholder="$t('liveRoomManagement.liveRoomList.List.filter.placeholderInput')"
                            />
                        </li>
                        <li>
                            <span>{{ $t('liveRoomManagement.liveRoomList.List.filter.roomTitle') }}</span>
                            <Input
                                class="selector"
                                v-model="filter.roomTitle"
                                size="small"
                                clearable
                                :placeholder="$t('liveRoomManagement.liveRoomList.List.filter.placeholderInput')"
                            />
                        </li>
                        <li>
                            <span>{{ $t('liveRoomManagement.liveRoomList.List.filter.status.title') }}</span>
                            <Select
                                transfer
                                clearable
                                class="selector"
                                v-model="filter.status"
                                size="small"
                                :placeholder="$t('liveRoomManagement.liveRoomList.List.filter.placeholderSelect')"
                            >
                                <Option :value="1">{{ $t('liveRoomManagement.liveRoomList.List.filter.status.streamming') }}</Option>
                            </Select>
                        </li>
                        <li>
                            <DepartmentSelect filterPath="views/liveRoom.all.filter"></DepartmentSelect>
                            <!-- <div v-if="filter.selectType == 2"  class="department-bar" style="display: inline-block">
                                <span>{{ $t('Home.Header.department') }}</span>
                                <span class="department-text"  @click.stop="departmentBar.selecting = !departmentBar.selecting">
                                    <span :title="departmentName">{{departmentName}}</span>
                                    <icon class="icon" :type="departmentBar.selecting ? 'md-arrow-dropup' : 'md-arrow-dropdown'"></icon>
                                 <div class="department-select" v-show="departmentBar.selecting" @click.stop="departmentBar.selecting = true">
                                <Tree ref="departmentBarTree" :data="departmentBar.treeData" show-checkbox check-directly check-strictly
                                      @on-check-change="onDepartmentTreeCheck"></Tree>
                                </div>
                                </span>
                            </div>                   -->
                        </li>
                        <li v-if="filter.selectType == 3">
                            <UserGroupSelect v-model="groupIdSelected.id" ></UserGroupSelect>
                            <!-- <UserGroupSelect v-model="groupIdSelected.id" @input="ontest" ></UserGroupSelect> -->
                            <!-- <span>{{ $t('liveRoomManagement.liveRoomList.List.filter.userGroupTitle') }}</span>
                            <Select
                                transfer
                                clearable
                                class="selector"
                                v-model="groupIdSelected.id"
                                size="small"
                                :placeholder="$t('liveRoomManagement.liveRoomList.List.filter.placeholderSelect')"
                                @on-select="selectUserGroup"
                            >-->
                                <!-- v-model="filter.globalCategoryNameLike" -->
                            <!--
                                <Option
                                        v-for="item in userGroupList"
                                        :value="item.id"
                                        :key="item.id"
                                >{{ localize(item.name) }}</Option>
                            </Select> -->
                        </li>
                    </ul>
                    <ul class="filter-box" v-show="advanceSearch">
                        <li>
                            <span>{{ $t('liveRoomManagement.liveRoomList.List.filter.publishStatus.title') }}</span>
                            <Select
                                transfer
                                clearable
                                class="selector"
                                v-model="filter.publishStatus"
                                size="small"
                                :placeholder="$t('liveRoomManagement.liveRoomList.List.filter.placeholderSelect')"
                            >
                                <Option :value="0">{{ $t('liveRoomManagement.liveRoomList.List.filter.publishStatus.close') }}</Option>
                                <Option :value="1">{{ $t('liveRoomManagement.liveRoomList.List.filter.publishStatus.issue') }}</Option>
                            </Select>
                        </li>
                        <li v-if="dep||(filter.selectType==3)">
                            <span>{{ $t('liveRoomManagement.liveRoomList.List.filter.userCode') }}</span>
                            <Input
                                class="selector"
                                v-model="filter.userCode"
                                size="small"
                                clearable
                                :placeholder="$t('liveRoomManagement.liveRoomList.List.filter.placeholderInput')"
                            />
                        </li>
                        <li>
                            <span>{{ $t('liveRoomManagement.liveRoomList.List.filter.globalCategoryNameLike') }}</span>
                            <Select
                                transfer
                                clearable
                                class="selector"
                                v-model="filter.globalCategoryNameLike"
                                size="small"
                                :placeholder="$t('liveRoomManagement.liveRoomList.List.filter.placeholderSelect')"
                            >
                                <Option
                                        v-for="item in globalCategoryList"
                                        :value="item.name"
                                        :key="item.id"
                                >{{ localize(item.name) }}</Option>
                            </Select>
                        </li>
                        <li v-if="!dep">
                            <span>{{ $t('liveRoomManagement.liveRoomList.List.filter.categoryNameLike') }}</span>
                            <AutoComplete
                                class="selector"
                                :value="filter.categoryName"
                                size="small"
                                @on-change="val => !val && (categoryList = [])"
                                @on-select="onCategorySelect"
                                @on-search="searchCategoryList"
                                transfer
                                :placeholder="$t('liveRoomManagement.liveRoomList.List.filter.placeholderSelect')"
                            >
                                <div v-if="categoryList.length === 0" style="display: flex; align-items: center; justify-content: center;">
                                    暂无数据
                                </div>
                                <Option 
                                    v-for="category in categoryList" 
                                    :value="category.id" 
                                    :key="category.id"
                                >
                                    {{ category.name }}
                                </Option>
                            </AutoComplete>
                        </li>
                        <li v-if="listType!='slowlive'">
                            <span>{{ $t('liveRoomManagement.liveRoomList.List.filter.roomType') }}</span>
                            <Select
                                transfer
                                clearable
                                class="selector"
                                v-model="filter.roomType"
                                size="small"
                                :placeholder="$t('liveRoomManagement.liveRoomList.List.filter.placeholderSelect')"
                            >
                                <Option :value="1">{{ tt('liveRoomManagement.roomType.dedicated') }}</Option>
                                <Option :value="2">{{ tt('liveRoomManagement.roomType.publish') }}</Option>
                                <Option v-if="hasPermission('linkLive')" :value="4">{{ $t('liveRoomManagement.roomType.linkLiveRoom') }}</Option>
                            </Select>
                        </li>
                    </ul>
                </div>
                <div class="filter">
                    <!--排序功能-->
                    <span>{{ $t('liveRoomManagement.liveRoomList.List.sortType.title') }}</span>
                    <Button
                        :type="createTimeType"
                        :icon="createTimeIcon"
                        @click="switchCreateSortType"
                    >{{ $t('liveRoomManagement.liveRoomList.List.sortType.createTime') }}</Button>
                    <Button
                        :type="liveTimeType"
                        :icon="liveTimeIcon"
                        @click="switchLiveSortType"
                    >{{ $t('liveRoomManagement.liveRoomList.List.sortType.liveTime') }}</Button>
                    <!--显示模式-->
                    <div style="float: right">
                        <span>{{ $t('liveRoomManagement.liveRoomList.List.displayMode.title') }}</span>
                        <Icon type="ios-list" class="view_type" :class="{'view_type_active' : viewType == 1}" size="30" @click="viewType = 1" style="padding: 3px;"/>
                        <Icon type="ios-keypad" class="view_type" :class="{'view_type_active' : viewType == 2}" size="20" @click="viewType = 2" style=" padding: 8px;"/>
                        <Icon type="ios-menu" class="view_type" :class="{'view_type_active' : viewType == 3}" size="22" @click="viewType = 3" style="padding: 7px;"/>
                        <Select v-model="pagination.pageSize" transfer style="width: 80px;margin-left: 10px">
                            <Option :value="10">{{ $t('liveRoomManagement.liveRoomList.List.displayMode.pageSize.ps10') }}</Option>
                            <Option :value="20">{{ $t('liveRoomManagement.liveRoomList.List.displayMode.pageSize.ps20') }}</Option>
                            <Option :value="50">{{ $t('liveRoomManagement.liveRoomList.List.displayMode.pageSize.ps50') }}</Option>
                            <Option :value="100">{{ $t('liveRoomManagement.liveRoomList.List.displayMode.pageSize.ps100') }}</Option>
                        </Select>
                    </div>
                </div>
            </div>
            <div ref="list" class="content">
                <!--列表模式-->
                <ul v-if="viewType == 1" class="list-view-list">
                    <li
                        class="item"
                        :key="p.roomId"
                        v-for="p in list"
                    ><!-- @click="toDetail(p.roomId)" -->
                        <div class="item-thumb"  @click="toDetail(p.roomId)">
                            <LiveRoomImage :src="p.imageUrl" style="object-fit: contain;"/>
                            <div v-if="helper.isPublishedRoom(p)">
                                <span class="vodflag-tag" :style="{'backgroundColor': vodFlagColor(p.vodFlag)}">
                                    <PrettyText :text="Const.liveRoom.VodFlag(p.vodFlag)" />
                                </span>
                            </div>
                            <div>
                                <span class="viewnumber-tag">
                                    <Icon type="md-person" />
                                    {{ p.viewNumber }}
                                </span>
                            </div>
                        </div>
                        <div class="item-info">
                            <div class="item-right">
                                <ul class="list" style="width: 230px;list-style: none">
                                    <li v-if="helper.isPublishedRoom(p)">
                                    <span class="content-time">
                                        {{ $t('liveRoomManagement.liveRoomList.List.opList.timeDescription') }}{{ p.timeDescription }}
                                    </span>
                                    </li>
                                    <li>
                                    <span class="content-time">
                                        {{ $t('liveRoomManagement.liveRoomList.List.opList.createRoomTime') }}{{ p.createRoomTime }}
                                    </span>
                                    </li>
                                </ul>
                            </div>
                            <div class="item-left">
                                <div class="title">
                                    <!--直播间类型标志-->
                                    <span  @click="toDetail(p.roomId)"
                                        class="titleLink"
                                        :title="p.roomTitle"
                                    >
                                    <span v-decode="p.roomTitle.length>15?(p.roomTitle.substring(0,13)+'...'):p.roomTitle"/>
                                    </span>
                                    <span v-if="listType != 'slowlive'">（{{ p.roomType == 1 ? tt('liveRoomManagement.roomType.dedicatedLiveRoom')
                                        : (p.roomType == 5? $t('liveRoomManagement.roomType.slowLiveRoom')
                                        : (p.roomType == 4? $t('liveRoomManagement.roomType.linkLiveRoom'):tt('liveRoomManagement.roomType.publishLiveRoom'))) }}）</span>
                                    <span v-else style="margin-left:5px"></span>
                                    <!--直播间加密标志-->
                                    <span v-if="p.paidLive == 1" class="title-tag" style="background-color: #ff6666;margin-right: 5px">
                                        <Icon type="md-lock" size="12" style="color: #ffffff;"/>
                                    </span>
                                    <!--直播间发布状态标志-->
                                    <span v-if="helper.isPublishedRoom(p)" :class="p.publishStatus == 0 ? 'title-tag' : 'title-tag title-tag-act'">
                                        <PrettyText :text="Const.liveRoom.publishStatus(p.publishStatus)" />
                                    </span>
                                    <!--禁播标志-->
                                    <ForbiddenSpan :forbidden="p.forbidden" :memo="p.memo"></ForbiddenSpan>
                                    <!--推流标志-->
                                    <span v-show="p.status == 1" style="
                                        margin-left: 5px;
                                        padding: 2px;
                                        color: white;
                                        background-color: #FF6666;
                                        border-radius: 5px;
                                        font-size: 12px;
                                        text-align: center"
                                    >{{ $t('liveRoomManagement.liveRoomList.List.pushingTag') }}</span>
                                </div>
                                <ul class="list">
                                    <li>
                                        <span class="title">{{ $t('liveRoomManagement.liveRoomList.List.thumbList.roomId') }}</span>
                                        <span class="content">
                                            {{p.roomId}}
                                        </span>
                                    </li>
                                    <li v-if="dep||(filter.selectType==3)">
                                        <span class="title">{{ $t('liveRoomManagement.liveRoomList.List.thumbList.userName') }}</span>
                                        <span class="content">
                                            {{p.userName}}
                                        </span>
                                    </li>
                                    <li>
                                        <span class="title">{{ $t('liveRoomManagement.liveRoomList.List.thumbList.globalCategoryName') }}</span>
                                        <span class="content">
                                            {{ p.globalCategoryName == '' ? $t('Message.explainEmpty') : p.globalCategoryName }}
                                        </span>
                                    </li>
                                    <li>
                                        <span class="title">{{ $t('liveRoomManagement.liveRoomList.List.thumbList.categoryName') }}</span>
                                        <span class="content">
                                            {{ !p.categoryName ? $t('Message.explainEmpty') : p.categoryName }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div @click="e=>e.stopPropagation()" style="white-space: normal;overflow: visible;padding-right: 50px;">
                                <CommonRoomButton v-if="!isNfplus" :room="p" type="share"></CommonRoomButton>
                            <span>
                                <CommonRoomButton v-if="listType!='slowlive'" :room="p" :btnUrl="'/home/liveRoom_list/detail/edit/'" type="edit"></CommonRoomButton>
                                <CommonRoomButton v-else :room="p" :btnUrl="'/home/liveRoom_list/detail/editslowlive/'" type="edit"></CommonRoomButton>
                                <CommonRoomButton :room="p" type="vodFlag" @loading="loading=$event" @update="refresh"></CommonRoomButton>
                                <CommonRoomButton :room="p" type="liveUrl"></CommonRoomButton>
                                <CommonRoomButton v-if="!isNfplus" :room="p" :selectType="filter.selectType" type="wordLive"></CommonRoomButton>
                                <CommonRoomButton v-if="!isNfplus" :room="p" :selectType="filter.selectType" type="relatedReport"></CommonRoomButton>
                                <CommonRoomButton v-if="!isNfplus" :room="p" :selectType="filter.selectType" type="relatedReportSettings"></CommonRoomButton>
                                <CommonRoomButton v-if="!isNfplus" :room="p" :selectType="filter.selectType" type="commentManagement"></CommonRoomButton>
                                <CommonRoomButton v-if="!isDAYOO" :selectType="filter.selectType" :room="p" type="realEditor"></CommonRoomButton>
                                <CommonRoomButton :room="p" type="publish" @loading="loading=$event" @update="refresh"></CommonRoomButton>
                                <CommonRoomButton v-if="p.userId==userId" :room="p" type="delete" @update="refresh"></CommonRoomButton>
                            </span>
                                <!-- <CommonRoomButton v-if="p.userId==userId||filter.selectType != 3" :room="p" type="delete" @update="refresh"></CommonRoomButton> -->
                            </div>
                        </div>
                    </li>
                </ul>
                <!--宫格模式-->
                <ul v-else-if="viewType == 2" class="list-view-grid">
                    <li
                        class="item"
                        :key="p.roomId"
                        v-for="p in list"
                        @click="toDetail(p.roomId)"
                    ><!-- @click="toDetail(p.roomId)"-->
                        <div class="item-thumb"><!-- @click="toDetail(p.roomId)"-->
                            <LiveRoomImage  :src="p.imageUrl" style="object-fit: contain;"/>
                            <div>
                                <span class="vodflag-tag" :style="{'backgroundColor': vodFlagColor(p.vodFlag)}">
                                    <PrettyText :text="Const.liveRoom.VodFlag(p.vodFlag)" />
                                </span>
                            </div>
                            <div>
                                <span class="viewnumber-tag">
                                    <Icon type="md-person" />
                                    {{ p.viewNumber }}
                                </span>
                            </div>
                            <div>
                                <div class="title">
                                    <div class="title-link">
                                        <span class="titleLink"  :title="p.roomTitle">{{p.roomTitle.length>15?(p.roomTitle.substring(0,13)+'...'):p.roomTitle}}</span><!-- @click="toDetail(p.roomId)"-->
                                    </div>
                                    <ForbiddenSpan :forbidden="p.forbidden" :memo="p.memo"></ForbiddenSpan>
                                </div>
                                <div class="info" @click="e=>e.stopPropagation()">
                                    <span>ID:</span>
                                    <span>{{p.roomId}}</span>
                                    <MoreInfo v-if="p.roomType!=5" :selectType="filter.selectType" :p="p" :btnUrl="'/home/liveRoom_list/detail/edit/'" @loading="loading=$event" @update="refresh"></MoreInfo>
                                    <MoreInfo v-else :selectType="filter.selectType" :p="p" :btnUrl="'/home/liveRoom_list/detail/editslowlive/'" @loading="loading=$event" @update="refresh"></MoreInfo>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
                <!--表格模式-->
                <div v-else-if="viewType == 3" class="list-view-table">
                    <div style="height: 20px;width: 100%"></div>
                    <Table border :columns="liveRoomTable" :data="list" @on-selection-change="changeRoom" :no-data-text="$t('Message.noData')"></Table>
                    <div style="width: 100%;margin-top: 10px" v-if="filter.selectType==1">
                        <!-- <Button type="primary" icon="md-remove" @click="removeBatch"> -->
                        <Button type="primary" icon="md-remove" @click.stop="showRemoveConfirm()">
                            <RemoveConfirmDialog :visible="removeDialog.visible"
                                title="批量删除直播间"
                                @remove="onRemoveConfirm()"
                                @cancel="removeDialog.visible = false" />
                            {{ $t('liveRoomManagement.liveRoomList.List.removeBatch') }}
                        </Button>
                    </div>
                </div>
                <Spin v-show="loading" fix class="spin">
                    <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                    <div>Loading</div>
                </Spin>
                <Page
                        class="pager"
                        :total="pagination.total"
                        :current="pagination.page"
                        :page-size="pagination.pageSize"
                        :page-size-opts="[10,20,50,100]"
                        @on-change="v=>pagination.page=v"
                        @on-page-size-change="v=>pagination.pageSize=v"
                        show-elevator
                        show-sizer
                        transfer
                />
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState, mapMutations } from "vuex";
    import api from "@/api/Api";
    import extend from "extend";
    import apimodel from "@/model/ApiModel";
    import helper from "@/assets/helper.js";
    import config from "@/config";
    import logger from "@/assets/log";
    import DepartmentSelect from "@/components/DepartmentSelect";
    import UserGroupSelect from "@/components/UserGroupSelect";
    import PrettyText from "@/components/PrettyText";
    import LiveRoomImage from "@/components/LiveRoomImage";
    import MoreInfo from "@/components/MoreInfo";
    import CommonRoomButton from "@/components/CommonRoomButton";
    import ForbiddenSpan from "@/components/ForbiddenSpan";
    import RemoveConfirmDialog from "@/components/RemoveConfirmDialog";

    const log = logger("views:material:all");

    let { Const } = apimodel;

    export default {
        components: {
            UserGroupSelect,
            DepartmentSelect,
            PrettyText,
            LiveRoomImage,
            MoreInfo,
            CommonRoomButton,
            ForbiddenSpan,
            RemoveConfirmDialog
        },
        mixins: [
            {
                methods: helper
            }
        ],
        props:["listType"], 
        data() {
            return {
                groupIdSelected: {
                    id: this.$store.state.user.defaultSelectedUserGroup,
                    groupData: []
                },
                Const,
                loading: true,
                // departmentBar: {
                //     selecting: false,
                //     treeData: []
                // },
                portrait: this.isPortrait(),
                side_hide: this.isPortrait(),
                liveRoomTable: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: this.$t('liveRoomManagement.liveRoomList.List.liveRoomTable.roomId'),
                        key: 'roomId',
                        align: 'center',
                        maxWidth: 120
                    },
                    {
                        title: this.$t('liveRoomManagement.liveRoomList.List.liveRoomTable.roomTitle'),
                        key: 'roomTitle',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style: {
                                        borderBottom: '1px solid #1a81b0',
                                        cursor: 'pointer'
                                    },
                                    on: {
                                        click: () => {
                                            this.toDetail(params.row.roomId)
                                        }
                                    },
                                },params.row.roomTitle)
                            ])
                        }
                    },
                    // {
                    //     title: this.$t('liveRoomManagement.liveRoomList.List.thumbList.userName'),
                    //     key: 'roomTitle',
                    //     align: 'center',
                    //     render: (h, params) => {
                    //         return h('div', [
                    //             h('span', {
                    //                 style: {
                    //                     borderBottom: '1px solid #1a81b0',
                    //                     cursor: 'pointer'
                    //                 }
                    //             },params.row.userName)
                    //         ])
                    //     }
                    // },
                    {
                        title: this.$t('liveRoomManagement.liveRoomList.List.liveRoomTable.userName'),
                        key: 'userName',
                        align: 'center',
                        maxWidth: 120
                    },
                    {
                        title: this.$t('liveRoomManagement.liveRoomList.List.liveRoomTable.status'),
                        key: 'status',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    props: {
                                        // vShow: params.row.paidLive === 1,
                                    },
                                    style: {
                                        display: params.row.paidLive === 1 ? 'inline-block' : 'none',
                                        backgroundColor: '#ff6666',
                                        marginRight: '5px',
                                        borderRadius: '5px',
                                        fontSize: '12px',
                                        padding: '0 2px',
                                    }
                                }, [h('Icon', {
                                    props: {
                                        type: 'md-lock',
                                        size: 12
                                    },
                                    style: {
                                        color: '#ffffff'
                                    }
                                })
                                ]),
                                h(PrettyText, {
                                    props: {
                                        text: this.Const.liveRoom.publishStatus(params.row.publishStatus)
                                    },
                                    style: {
                                        display: helper.isPublishedRoom(params.row)? 'inline-block' : 'none',
                                        backgroundColor: params.row.publishStatus === 1 ? '#7ECEF4' : '#A8A8A8',
                                        color: '#ffffff',
                                        borderRadius: '5px',
                                        fontSize: '12px',
                                        padding: '0 2px',
                                    }
                                }),
                                h(ForbiddenSpan, {
                                    props: {
                                        forbidden: params.row.forbidden,
                                        memo: params.row.memo,
                                    }
                                }),
                                h('span', {
                                    props: {},
                                    style: {
                                        display: params.row.status === 1 ?  'inline-block' : 'none',
                                        backgroundColor: '#FF6666',
                                        color: '#ffffff',
                                        marginRight: '5px',
                                        borderRadius: '5px',
                                        fontSize: '12px',
                                        padding: '0 2px',
                                    }
                                }, this.$t('liveRoomManagement.liveRoomList.List.pushingTag'))
                            ])
                        }
                    },
                    {
                        title: this.$t('liveRoomManagement.liveRoomList.List.liveRoomTable.roomType'),
                        key: 'roomType',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', params.row.roomType === 1 ? this.tt('liveRoomManagement.roomType.dedicatedLiveRoom')
                                    : (params.row.roomType == 5? this.$t('liveRoomManagement.roomType.slowLiveRoom')
                                    : (params.row.roomType == 4? this.$t('liveRoomManagement.roomType.linkLiveRoom'):this.tt('liveRoomManagement.roomType.publishLiveRoom'))))
                            ])
                        }
                    },
                    {
                        title: this.$t('liveRoomManagement.liveRoomList.List.liveRoomTable.operation'),
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h(MoreInfo, {
                                    props: {
                                        selectType:this.filter.selectType,
                                        p: params.row,
                                        btnUrl: params.row.roomType!=5?'/home/liveRoom_list/detail/edit/':'/home/liveRoom_list/detail/editslowlive/'
                                    },
                                    style: {

                                    },
                                    on: {
                                        loading: (loading) => this.loading = loading,
                                        update: () => this.refresh()
                                    }
                                })
                            ]);
                        }
                    }
                ],
                list: [],
                categoryList: [],
                globalCategoryList: [],
                file: null,
                liveRoomSettings: {},
                delList: {
                    ids: '',
                    isPush: false
                },
                helper,
				advanceSearch: false,
                // 删除确认
                removeDialog: {
                    visible: false,
                }
            };
        },
        computed: {
            viewType: {
                get() {
                    return this.$store.state.views.liveRoom.all.viewType;
                },
                set(v) {
                    this.$store.commit("views/liveRoom.all.viewType", v);
                }
            },
            filter: {
                get() {
                    return this.$store.state.views.liveRoom.all.filter;
                },
                set(v) {
                    this.$store.commit("views/liveRoom.all.filter", v);
                }
            },
            pagination: {
                get() {
                    return this.$store.state.views.liveRoom.all.pagination;
                },
                set(v) {
                    this.$store.commit("views/liveRoom.all.pagination", v);
                }
            },
            showUploader: {
                set(n) {
                    this.$store.commit("uploader/showUploader", false);
                },
                get() {
                    return this._showUploader;
                }
            },
            ...mapState({
                userId: state => state.user.id,
                isDAYOO: state => state.config.profile == 'dayoo',
                isNfplus: state => state.config.profile == 'nfplus',
                userName: state => state.user.name,
                departmentName: state => state.department.currentName,
                departmentId: state => state.department.currentId,
                shareId: state => state.user.defaultSelectedUserGroup
            }),
            dep(){
                return this.filter.selectType == 2
            },
            createTimeType() {
                let type = '';
                if(this.filter.sortType == 1 || this.filter.sortType == 2){
                    type = 'info'
                }else {
                    type = 'default'
                }
                return type;
            },
            liveTimeType() {
                let type = '';
                if(this.filter.sortType == 3 || this.filter.sortType == 4){
                    type = 'info'
                }else {
                    type = 'default'
                }
                return type;
            },
            createTimeIcon() {
                let icon = '';
                if(this.filter.sortType == 1){
                    icon = 'md-arrow-up'
                }else if(this.filter.sortType == 2){
                    icon = 'md-arrow-down'
                }
                return icon;
            },
            liveTimeIcon() {
                let icon = '';
                if(this.filter.sortType == 3){
                    icon = 'md-arrow-up'
                }else if(this.filter.sortType == 4){
                    icon = 'md-arrow-down'
                }
                return icon;
            },
            vodFlagColor(){
                return (vodFlag) => {
                    switch (vodFlag){
                        case 0:return '#FF6666';
                        case 1:return 'gray';
                        case 2:return '#005757';
                        case 3:return '#2F8AD1';
                    }
                }
            }
        },
        watch: {
            // 'departmentBar.selecting'(yes) {
            //     yes && this.getDepartmentList();
            // },
            'groupIdSelected.id'(){
                this.pagination.page = 1;
                this.refresh(); 
            },
            'filter.depId'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.roomId'() {
                if (!(/(^[1-9]\d*$)/.test(this.filter.roomId)) && this.filter.roomId != '') {
                    this.$Message.info(this.$t('Message.enterInteger'))
                }else {
                    this.pagination.page = 1;
                    this.refresh();
                }
            },
            'filter.roomTitle'() {
                if(this.containsInvaildChar(this.filter.roomTitle)) {
                    return;
                }
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.userCode'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.globalCategoryNameLike'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.categoryId'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.roomType'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.publishStatus'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.selectType'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.sortType'() {
                this.pagination.page = 1;
                this.refresh();
            },
            "pagination.page"() {
                this.refresh();
            },
            "pagination.pageSize"() {
                this.pagination.page = 1;
                this.refresh();
            },
            "viewType"(){
                this.refresh();
            },
            'filter.status'() {
                this.pagination.page = 1;
                this.refresh();
            },
            uploaderResult(val) {
                let item = val[val.length - 1];
                if (!item.status) {
                    this.pagination.page == 1 && this.refresh();
                } else {
                    ;
                }
            }
        },
        methods: {
            //  async getDepartmentList() {
            //     try {
            //         let ret = await api.call("department/getDepList", {}, true);
            //         let tree = helper.getTree(ret.data, 'pId', ret.data[0].pId);
            //         helper.travel(tree, "children", n => {
            //             n.title = n.name;
            //             n.checked = (n.id == this.$store.state.department.currentId);
            //             n.expand = helper.hasCheckedNode(n, this.depId)
            //         });
            //         if(tree[0]) {
            //             tree[0].expand = true;
            //         }
            //         this.departmentBar.treeData = tree;
            //     } catch (e) {
            //     this.$Notice.error({
            //             title: e.message
            //         });
            //     }
            // },
            // onDepartmentTreeCheck(checked, curr) {
            //     // 只允许选择一个节点
            //     checked.forEach(n => n.checked = false);
            //     curr.checked = true;

            //     this.departmentBar.selecting = false;
            //     this.$store.commit("department/current", {
            //         id: curr.id,
            //         name: curr.title
            //     });
            // },
            toDetail(id){
                if(this.hasPermission('直播间详情功能')){
                    if("slowlive" != this.listType) {
                        this.$router.push('detail/' + id + "/" + this.filter.selectType);
                    } else {
                        this.$router.push('detailslowlive/' + id + "/" + this.filter.selectType);
                    }
                }else {
                    this.$Notice.error({ title: this.$t('Message.permission.error') })
                }
            },
            // 切换排序方式
            switchCreateSortType(){
                if(this.filter.sortType == 3 || this.filter.sortType == 4){
                    this.filter.sortType = 2;
                }else if(this.filter.sortType == 1){
                    this.filter.sortType = 2;
                }else this.filter.sortType = 1;
            },
            // 切换排序方式
            switchLiveSortType(){
                if(this.filter.sortType == 1 || this.filter.sortType == 2){
                    this.filter.sortType = 4;
                }else if(this.filter.sortType == 3){
                    this.filter.sortType = 4;
                }else this.filter.sortType = 3;
            },
            changeRoom(selection){
                this.delList = {
                    ids: [],
                    isPush: false
                };
                for(let i = 0; i < selection.length; i++){
                    this.delList.ids.push(selection[i].roomId)
                }
                if(selection.filter(i => {
                    return i.status == 1
                }).length > 0){
                    this.delList.isPush = true
                }
            },
            // 批量删除
            //删除直播间
            async showRemoveConfirm() {
                this.removeDialog.visible = true;
            },
            // async removeBatch(){
            async onRemoveConfirm() {
                this.removeDialog.visible = false;

                if(this.delList.ids.length == 0){
                    this.$Message.info(this.$t('Message.remove.batch.none'));
                    return
                }
                if(this.delList.isPush){
                    this.$Message.info(this.$t('Message.remove.batch.isPush'));
                    return
                }

                this.loading = true;

                try {
                    let ret = await api.call("liveRoom/deleteLiveRoomList", {
                        ids: this.delList.ids
                    }, null, true);

                    this.$Notice.success({ title: this.$t('Message.remove.success') });
                    this.refresh();
                } catch (e) {
                    this.$Notice.error({ title: this.$t('Message.remove.error'), desc: e.resultMsg });
                }
                this.loading = false;
            },
            async refresh(withoutLoading) {
                !withoutLoading && (this.loading = true);
                
                try {
                    let param = extend(true, {}, this.pagination, this.filter);
                    delete param.categoryName;
                    delete param.categoryNameLike;
                    if(this.filter.selectType == 3){
                        param.shareId = this.shareId
                    }
                    // 慢直播间与其他类型的直播间分开查询
                    if("slowlive" == this.listType) {
                        param.roomType = 5;
                        param.roomTypes = "";
                    } else {
                        param.roomTypes = "1,2,4";
                    }
                    let ret = [];
                    ret = await api.call("liveRoom/list", param);
                    this.list = ret.list;
                    this.pagination.total = ret.total;
                    
                } catch (e) {
					this.$Notice.error({
						title: this.$t(e && e.reject ?
							'Message.permission.error' :
							'Message.callResult.retry')
					});
					this.list = [];
                    this.pagination.total = 0 ;
                }

                this.loading = false;

                !withoutLoading &&
                this.$nextTick(() => {
                    this.$refs.list.parentElement.parentElement.parentElement.scrollTo(
                        0,
                        0
                    );
                });
            },
            async refreshFilter(){
                try {
                    const [globalCategory/*, category*/] = await Promise.all([
                        api.call("liveRoomCategory/globalCategoryList"),
                        // api.call("liveRoomCategory/list", {
                        //     selectType: 1,
                        //     userId: this.userId
                        // })
                    ]);
                    // let globalCategory = await api.call("liveRoomCategory/globalCategoryList");
                    this.globalCategoryList = globalCategory.list;
                    // this.categoryList = category.list;
                } catch (e) {
                    console.error(e);
                }
            },
            async searchCategoryList(val) {
                const params = {
                    depId: this.filter,
                    selectType: this.filter.selectType,
                    userId: this.userId,
                    nameLike: val,
                }
                if (params.selectType === 3) {
                    Object.assign(params, {
                        shareId: this.shareId
                    });
                }
                const { list } = await api.call("liveRoomCategory/listSimple",params);
                this.categoryList = list;
            },
            onCategorySelect(id) {
                const item = this.categoryList.find(item => item.id === id);
                if (item) {
                    this.filter.categoryName = item.name;
                    this.filter.categoryId = item.id;
                } else {
                    this.filter.categoryName = '';
                    this.filter.categoryId = null;
                }
            }
        },
        mounted() {

            this.isPortrait((e)=>{ 
                this.$data.portrait = e.matches;
                this.$data.side_hide = e.matches;
            })
            this.refresh();
            this.refreshFilter();
        },
        created() {
        },
        beforeDestroy() {

        },
       
    };
</script>

<style lang="less" scoped>
    @keyframes spin1 {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .box {
        min-height:400px
    }
    .header {
        & > * {
            margin-bottom: 10px;
            border-radius: 5px;
        }
        .toolbar {
            height: 32px;
            line-height: 32px;

            button {
                margin-right: 22px;
                vertical-align: middle;
            }

            .search {
                width: 200px;
            }
        }
    }
    .content {
        position: relative;
        border-radius: 5px;
        background: white;
        padding: 0 20px;

        .spin {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }
    .content-time{
        position: relative;
        border-radius: 5px;
        background: white;
        margin-right: 10px;
        color: #515a6e;

        .spin {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }

    .filter{
        /*overflow:hidden;*/
        // white-space: nowrap;
        position: relative;
        .view_type{
            margin-left: 5px;
            display: inline-block;
            line-height: 1em;
            cursor: pointer;
            border-radius: 5px;
            transition: color 0.2s linear, background-color 0.2s linear, border 0.2s linear, box-shadow 0.2s linear, -webkit-box-shadow 0.2s linear;
        }
        .view_type_active, .view_type:hover{
            background-color: #2db7f5;
            color: #ffffff;
        }
		.filter-box {
			display: block;
			li {
				margin-bottom: 5px
			}
		}
    }
    .filter-expend{
        overflow: visible;
        white-space: normal;
        position: static;
        .filter-box li{
            margin:5px 5px;
        }
        .more-btn{
            position:relative
        }
    }

    .list-view-list {
        list-style: none;
        padding: 0 7px;
        border-radius: 5px;
        background: white;

        .item {
            border-bottom: 1px solid #e9e9e8;
            height: 100%;
            white-space: nowrap;
            position: relative;
            padding: 15px 0;
            display: flex;
            align-items: center;

            .titleLink {
                font-size: 15px;
            }

            .title-tag {
                border-radius: 5px;
                font-size: 12px;
                background: #A8A8A8;
                padding: 2px;
                color: white;
            }
            .title-tag-forbidden{
                cursor: pointer;
            }
            .title-tag-act{
                background-color: rgb(126, 206, 244);
            }
            .item-thumb {
                height: 90px;
                // 如果设置 line-height: 90px 内容会下移1px，原因不明
                /*line-height: 89px;*/
                width: 160px;
                border-radius: 5px;
                overflow: hidden;
                position: relative;
                margin-right: 12px;
                
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    vertical-align: middle;
                    border: 0;
                }
                canvas {
                    width: 100%;
                    border: 0;
                    vertical-align: middle;
                }
                .view {
                    width: 160px;
                    height: 90px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
                .view:hover {
                    cursor: pointer;
                    background: rgba(0, 0, 0, 0.3);
                }
                .view-icon {
                    visibility: hidden;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin: -12px 0 0 -12px;
                    color: #ffffff;
                    z-index: 1000;
                }
                .view:hover .view-icon {
                    visibility: visible;
                }
                .view:hover .play-btn {
                    visibility: visible;
                }
                .play-btn {
                    visibility: hidden;
                    width: 40px;
                    height: 40px;
                    font-size: 30px;
                    position: absolute;
                    cursor: pointer;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    background: rgba(255, 255, 255, 0.5);
                    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 10px;
                    border-radius: 40px;
                    i {
                        width: 100%;
                        height: 100%;
                        line-height: 40px;
                        text-align: center;
                        vertical-align: top;
                        padding-left: 5px;
                    }
                }
                .play-btn:hover {
                    background: #fff;
                }
                .vodflag-tag {
                    display: inline-block;
                    height: 18px;
                    position: absolute;
                    bottom: 10px;
                    left: 10px;
                    padding: 0 3px;
                    color: white;
                    border-radius: 5px;
                    text-align: center
                }
                .viewnumber-tag {
                    display: inline-block;
                    width: 46px;
                    height: 18px;
                    position: absolute;
                    bottom: 10px;
                    right: 10px;
                    color: #ffffff;
                    background-color: gray;
                    border-radius: 10px;
                    text-align: center
                }
            }
            .item-info {
                overflow: hidden;
                flex: 1;

                & > .title {
                    font-size: 15px;
                    color: #666;

                    & > * {
                        vertical-align: middle;
                    }
                    a {
                        margin-left: 5px;
                    }
                }
                .list {
                    color: #989898;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    line-height: 19px;

                    .title {
                        width: 60px;
                        display: inline-block;
                    }
                    .title:after {
                        content: ":";
                    }
                    .video-level-tag {
                        border-radius: 2px;
                        margin-right: 5px;
                        border-bottom: 1px dashed #e3e3e3;
                        cursor: pointer;
                    }
                    .video-level-tag:after {
                        content: "、";
                    }
                    .video-level-tag:last-child:after {
                        content: "";
                    }
                }
            }
            .item-right {
                float: right;
                width: 230px;
                background: white;
                text-align: right;
                white-space: normal;
                .delete_btn2 {
                    display: none;
                }
            }
            .item-left {
                overflow: hidden;

                .title {
                    width: 100%;
                    word-break: break-all;
                    word-wrap: break-word;
                    white-space: normal;
                }
            }
        }
    }
    .list-view-grid {
        list-style: none;
        padding: 0 7px;
        border-radius: 5px;
        background: white;
        .item {
            float: left;
            border: 1px solid #e9e9e8;
            height: 180px;
            padding: 15px 0;
            margin: 20px 10px;
            white-space: nowrap;
            position: relative;
            overflow: hidden;
            cursor: pointer;
            & > * {
                height: 100%;
                display: inline-block;
                vertical-align: middle;
            }
            .item-thumb {
                height: 90px;
                // 如果设置 line-height: 90px 内容会下移1px，原因不明
                /*line-height: 89px;*/
                width: 160px;
                border-radius: 5px;
                text-align: center;
                /*overflow: hidden;*/
                margin: 0 12px;
                position: relative;
                .title {
                    display: inline-block;
                    margin: 10px 0 0 0;
                    font-size: 15px;
                    color: #666;
                    & > * {
                        vertical-align: middle;
                    }
                    a {
                        margin-left: 5px;
                    }
                    .title-link{
                        display: inline-block;
                        width: 120px;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                    .title-tag{
                        border-radius: 5px;
                        font-size: 12px;
                        background: #A8A8A8;
                        padding: 2px;
                        color: white;
                    }
                }
                .vodflag-tag {
                    display: inline-block;
                    height: 18px;
                    position: absolute;
                    bottom: 10px;
                    left: 10px;
                    padding: 0 3px;
                    color: white;
                    border-radius: 5px;
                    text-align: center
                }
                .viewnumber-tag {
                    display: inline-block;
                    width: 46px;
                    height: 18px;
                    position: absolute;
                    bottom: 10px;
                    right: 10px;
                    color: #ffffff;
                    background-color: gray;
                    border-radius: 10px;
                    text-align: center
                }
                .info{
                    margin-top: 5px;

                    .item-info {
                        & > .title {
                            display: inline-block;
                            margin: 10px 0 0 0;
                            font-size: 15px;
                            color: #666;
                            & > * {
                                vertical-align: middle;
                            }
                            a {
                                margin-left: 5px;
                            }
                        }
                        .list {
                            color: #989898;
                            list-style: none;
                            margin: 0;
                            padding: 0;
                            line-height: 19px;

                            .title {
                                width: 60px;
                                display: inline-block;
                            }
                            .title:after {
                                content: ":";
                            }
                            .video-level-tag {
                                border-radius: 2px;
                                margin-right: 5px;
                                border-bottom: 1px dashed #e3e3e3;
                                cursor: pointer;
                            }
                            .video-level-tag:after {
                                content: "、";
                            }
                            .video-level-tag:last-child:after {
                                content: "";
                            }
                        }
                    }
                    .item-right {
                        position: absolute;
                        right: 0;
                        height: auto;
                        width: 230px;
                        background: white;
                        text-align: right;
                        white-space: normal;
                        .delete_btn2 {
                            display: none;
                        }
                    }
                }

            }
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                vertical-align: middle;
                border: 0;
            }
            canvas {
                width: 100%;
                border: 0;
                vertical-align: middle;
            }
            .view {
                width: 160px;
                height: 90px;
                position: absolute;
                top: 0;
                left: 0;
            }
            .view:hover {
                cursor: pointer;
                background: rgba(0, 0, 0, 0.3);
            }
            .view-icon {
                visibility: hidden;
                position: absolute;
                left: 50%;
                top: 50%;
                margin: -12px 0 0 -12px;
                color: #ffffff;
                z-index: 1000;
            }
            .view:hover .view-icon {
                visibility: visible;
            }
            .view:hover .play-btn {
                visibility: visible;
            }
            .play-btn {
                visibility: hidden;
                width: 40px;
                height: 40px;
                font-size: 30px;
                position: absolute;
                cursor: pointer;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                background: rgba(255, 255, 255, 0.5);
                box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 10px;
                border-radius: 40px;
                i {
                    width: 100%;
                    height: 100%;
                    line-height: 40px;
                    text-align: center;
                    vertical-align: top;
                    padding-left: 5px;
                }
            }
            .play-btn:hover {
                background: #fff;
            }
        }
    }
    .list-view-grid:after{
        clear:both;
        content:'';
        display:block;
        width:0;
        height:0;
        visibility:hidden;
    }
    .list-view-table {
        list-style: none;
        padding: 0 7px;
        border-radius: 5px;
        background: white;

        .item {
            border-bottom: 1px solid #e9e9e8;
            height: 140px;
            padding: 15px 0px;
            white-space: nowrap;
            position: relative;
            overflow: hidden;
            & > * {
                height: 100%;
                display: inline-block;
                vertical-align: middle;
            }

            .title-tag {
                border-radius: 5px;
                font-size: 12px;
                background: #A8A8A8;
                padding: 2px;
                color: white;
            }
            .title-tag-forbidden{
                cursor: pointer;
            }
            .item-thumb {
                height: 90px;
                // 如果设置 line-height: 90px 内容会下移1px，原因不明
                /*line-height: 89px;*/
                width: 160px;
                border-radius: 5px;
                overflow: hidden;
                margin-right: 12px;
                position: relative;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    vertical-align: middle;
                    border: 0;
                }
                canvas {
                    width: 100%;
                    border: 0;
                    vertical-align: middle;
                }
                .view {
                    width: 160px;
                    height: 90px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
                .view:hover {
                    cursor: pointer;
                    background: rgba(0, 0, 0, 0.3);
                }
                .view-icon {
                    visibility: hidden;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin: -12px 0 0 -12px;
                    color: #ffffff;
                    z-index: 1000;
                }
                .view:hover .view-icon {
                    visibility: visible;
                }
                .view:hover .play-btn {
                    visibility: visible;
                }
                .play-btn {
                    visibility: hidden;
                    width: 40px;
                    height: 40px;
                    font-size: 30px;
                    position: absolute;
                    cursor: pointer;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    background: rgba(255, 255, 255, 0.5);
                    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 10px;
                    border-radius: 40px;
                    i {
                        width: 100%;
                        height: 100%;
                        line-height: 40px;
                        text-align: center;
                        vertical-align: top;
                        padding-left: 5px;
                    }
                }
                .play-btn:hover {
                    background: #fff;
                }
            }
            .item-info {
                & > .title {
                    font-size: 15px;
                    color: #666;
                    & > * {
                        vertical-align: middle;
                    }
                    a {
                        margin-left: 5px;
                    }
                }
                .list {
                    color: #989898;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    line-height: 19px;

                    .title {
                        width: 60px;
                        display: inline-block;
                    }
                    .title:after {
                        content: ":";
                    }
                    .video-level-tag {
                        border-radius: 2px;
                        margin-right: 5px;
                        border-bottom: 1px dashed #e3e3e3;
                        cursor: pointer;
                    }
                    .video-level-tag:after {
                        content: "、";
                    }
                    .video-level-tag:last-child:after {
                        content: "";
                    }
                }
            }
            .item-right {
                position: absolute;
                right: 0;
                height: auto;
                width: 230px;
                background: white;
                text-align: right;
                white-space: normal;
                .delete_btn2 {
                    display: none;
                }
            }
        }
    }


    .pager {
        text-align: center;
        padding: 10px;
    }

    @media only screen and (max-width: 1440px) {
        .list .item .item-info > .title a {
            width: 80%;
        }
    }

    @media all and (orientation: portrait), all and (max-width: 1024px) {
        .list .item .item-right {
            background: transparent;
            .edit_btn {
                display: none;
            }
            .download_btn {
                display: none;
            }
            .delete_btn {
                display: none;
            }
            .delete_btn2 {
                display: inline-block;
            }
            bottom: 10px;
        }
        .list .item .item-thumb {
            width: 60px;
        }
        .content {
            padding: 0;
        }
    
}

</style>